// extracted by mini-css-extract-plugin
module.exports = {"button":"Web3ConnectionButtons_button__22U7L"};